import styled from "styled-components";

export const Container = styled.main`
  margin: 0 auto;
`;

export const Title = styled.h1`
  padding-top: 30px;
  padding-bottom: 24px;
  text-align: center;
  font-size: 24px;
  font-weight: 500;
`;

export const Section = styled.div`
  padding-bottom: 30px;
`;

export const ErrorMessage = styled.p`
  margin-top: 6px;
  font-size: 12px;
  color: #eb5757;
`;

export const SuccessMessage = styled.p`
  margin-top: 6px;
  font-size: 12px;
  color: #006cd8;
`;
